<div class="container">
 <div style="margin-top: 10px">
   <div class="row">
     <ng-container *ngFor="let module of modules">
       <div class="col-sm-3" *ngIf="module.active && module.id > 0">
         <div class="icon-menu">
           <div
             class="icon mat-elevation-z6"
             [style.background-color]="module.color"
             matRipple
             (click)="openSubmenu(module)"
           >
             <i [style.color]="module.colorIcon" class="fa iconFa" [ngClass]="module.icon"></i>
           </div>
           <div>
             <h3>{{ module.name }}</h3>
           </div>
         </div>
       </div>
     </ng-container>
   </div>
 </div>
</div>
